import React, { useEffect, useContext, useState } from "react";
import { AppContext } from "../../store/appContext";
import { useDispatchHelpers } from "../../store/dispatchhelper";
import axios from "axios";
import WebLoader from "../../components/webLoader/WebLoader";
import Banner from "../../components/banner/banner";
import "./calculator.scss";
import translate from "../../services/translation.json";
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import BarChart from "../../components/barGraph/barGraph";
import CalculatorTable from "../../components/calculatorTable/calculatorTable";
import { Fade } from "react-awesome-reveal";
const Calculator = () => {
  const {
    state: { baseUrl, calculator, calculatorTypes, lang },
  } = useContext(AppContext);
  const { dispatchAction } = useDispatchHelpers();
  const isDataReady = Object.keys(calculator).length > 0;
  const [selectedCalculatorType, setSelectedCalculatorType] = useState(
    calculatorTypes[0]?.name
  );
  const [calculatorResults, setCalculatorResults] = useState({});
  const [fieldValues, setFieldValues] = useState({});
  const [dataToGraph, setDataToGraph] = useState({});
  const handleFieldChange = (fieldName, value) => {
    setFieldValues((prevFieldValues) => ({
      ...prevFieldValues,
      [fieldName]: value,
    }));
  };
  const [selectedGraph, setSelectedGraph] = useState("ir1");
  const [selectedCurrency, setSelectedCurrency] = useState("CHF");
  const [showError, setShowError] = useState(false);
  useEffect(() => {
    axios.get(`${baseUrl}edelmetalle-calculator `).then((response) => {
      dispatchAction("setCalculatorTypesData", response?.data?.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGraphChange = (event) => {
    setSelectedGraph(event.target.value);
  };

  const handleCurrencyChange = (event) => {
    setSelectedCurrency(event.target.value);
  };

  useEffect(() => {
    if (calculatorTypes?.length > 0) {
      const calculatorType = calculatorTypes[0];
      setSelectedCalculatorType(calculatorTypes[0]?.name);
      axios
        .get(`${baseUrl}edelmetalle-calculator/${calculatorType.id} `)
        .then((response) => {
          dispatchAction("setCalculatorData", response?.data?.data);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calculatorTypes]);

  useEffect(() => {
    // Find all span elements inside a div with class "page-container" that have style="color: white;"
    const spans = document.querySelectorAll(
      '.page-container span[style="color: white;"]'
    );
    // Add a class to each of these spans
    spans.forEach((span) => {
      span.classList.add("white-text");
    });
     // Find all span elements that have style="color: rgb(212, 185, 123);"
     const goldSpans = document.querySelectorAll(
      ' span[style="color: rgb(212, 185, 123);"]'
    );
    // Add a class to each of these spans
    goldSpans.forEach((span) => {
      span.classList.add("gold-text");
    });
  }, [calculator]);

  const handleCalculate = () => {
    // Check if fieldValues is empty
    const areAllFieldsFilled =(Object.keys(fieldValues).length !== 0)
    if (areAllFieldsFilled) {
      // All fields are filled
      axios
        .post(
          `${baseUrl}edelmetalle-calculator/${calculatorTypes[0].id}`,
          fieldValues
        )
        .then((response) => {
          setCalculatorResults(response.data.data);
        })
        .catch((error) => {
          console.error("Error calculating:", error);
        });
    } else {
      setShowError(true);
    }
  };

  useEffect(() => {
    getGraphData();
    // eslint-disable-next-line
  }, [calculatorResults]);

  const getGraphData = () => {
    if (fieldValues["X1"] !== "0" && fieldValues["X2"] !== "0") {
      setDataToGraph(calculatorResults["X1 > 0 And X2 > 0"]);
    } else if (fieldValues["X1"] !== "0" && fieldValues["X2"] === "0") {
      setDataToGraph(calculatorResults["X2 = 0 And X1 > 0"]);
    } else {
      setDataToGraph(calculatorResults["X1 = 0 And X2 > 0"]);
    }
  };
  const tableType = [
    translate[lang].calculator.pessimistic,
    translate[lang].calculator.nuetral,
    translate[lang].calculator.optimistic,
  ];

  const renderTables = () => {
    return (
      <div className="calculator-table-container">
        {dataToGraph &&
          Object.keys(dataToGraph.data).map((item, i) => {
            return (
              <CalculatorTable
                key={i}
                data={dataToGraph.data[item]}
                type={tableType[i]}
                lang={lang}
                curr={selectedCurrency}
              />
            );
          })}
      </div>
    );
  };

  const formatNumberWithCommas = (number) => {
    // Handle cases where the input is null, undefined, or an empty string
    if (number === null || number === undefined || number === "") {
      return "";
    }
    // Convert the input to a number
    const numericValue = Number(number);

    // Check if the conversion was successful
    if (isNaN(numericValue)) {
      throw new Error("Input must be a valid number");
    }
    // Format the number with commas
    return numericValue.toLocaleString("en-US");
  };

  const renderCalculatorComponent = () => {
    return (
      <div className="calculator-container">
        <div className="calculator-fields">
          <FormControl
            fullWidth
            className="currency-select"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "#C2A665", // Gold border
                },
                "&:hover fieldset": {
                  borderColor: "#C2A665", // Gold border on hover
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#C2A665", // Gold border when focused
                },
              },
            }}
          >
            <InputLabel id="selected-option">Currency</InputLabel>
            <Select
              labelId="selected-option"
              id="curreny-select"
              value={selectedCurrency}
              label={translate[lang].calculator.currency}
              onChange={handleCurrencyChange}
              sx={{
                "& .MuiSelect-select": {
                  color: "#C2A665",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#C2A665",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#C2A665",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#C2A665",
                },
              }}
            >
              <MenuItem value="CHF">CHF</MenuItem>
              <MenuItem value="EUR">EUR</MenuItem>
            </Select>
          </FormControl>
          {calculator.edelmetalle_calculator.calculator_details[0].inputs.map(
            (item, i) => {
              const calcName = selectedCalculatorType
                .split(" ")
                .join("_")
                .toLowerCase();
              return (
                <TextField
                  InputLabelProps={{
                    style: {
                      color: "#C2A665",
                      borderColor: "#C2A665",
                      width: "30%",
                    },
                  }}
                  InputProps={{
                    startAdornment:
                      i !== 2 ? (
                        <InputAdornment position="start">
                          {selectedCurrency}
                        </InputAdornment>
                      ) : (
                        ""
                      ),
                  }}
                  sx={{
                    "& input[type=number]": {
                      "-moz-appearance": "textfield",
                      "&::-webkit-outer-spin-button": {
                        "-webkit-appearance": "none",
                        margin: 0,
                      },
                      "&::-webkit-inner-spin-button": {
                        "-webkit-appearance": "none",
                        margin: 0,
                      },
                    },
                    "& .MuiFilledInput-root": {
                      "&:before": {
                        borderBottomColor: "#C2A665", // Default border color
                      },
                      "&:hover:not(.Mui-disabled):before": {
                        borderBottomColor: "#C2A665", // Hover border color
                      },
                      "&:after": {
                        borderBottomColor: "transparent", // Focused border color
                      },
                    },
                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#C2A665", // Label color when focused
                    },
                  }}
                  value={formatNumberWithCommas(fieldValues[item]) || 0}
                  onChange={(e) => {
                    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas
                    if (!isNaN(rawValue)) {
                      handleFieldChange(item, rawValue); // Update state with the raw number
                    }
                  }}
                  label={translate[lang].calculator[calcName][item]}
                  variant="outlined"
                  type="text" // Use text to allow formatted display
                  inputMode="decimal" // Ensure numeric input behavior
                  className="mui-textfield"
                  key={`calculator-field-${i}`}
                />
              );
            }
          )}
        </div>
        {showError && <p>{translate[lang].calculator.errorMessage}</p>}
        <p className="calculator-btn" onClick={handleCalculate}>
          {translate[lang].calculator.calculate}
        </p>
        <span className="calculator-note">
          {translate[lang].calculator.disclaimer}
        </span>
        {Object.keys(calculatorResults).length > 0 && (
          <div className="calculator-graph">
            <FormControl
              fullWidth
              className="calculator-select"
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "#C2A665", // Gold border
                  },
                  "&:hover fieldset": {
                    borderColor: "#C2A665", // Gold border on hover
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#C2A665", // Gold border when focused
                  },
                },
              }}
            >
              <InputLabel id="selected-option">Options</InputLabel>
              <Select
                labelId="selected-option"
                id="graph-select"
                value={selectedGraph}
                label="Options"
                onChange={handleGraphChange}
                sx={{
                  "& .MuiSelect-select": {
                    color: "#C2A665",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#C2A665",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#C2A665",
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#C2A665",
                  },
                }}
              >
                <MenuItem value="ir1">Intrest rate 1</MenuItem>
                <MenuItem value="ir2">Intrest rate 2</MenuItem>
                <MenuItem value="ir3">Intrest rate 3</MenuItem>
              </Select>
            </FormControl>
            <div className="graph-container">
              {dataToGraph && (
                <BarChart data={dataToGraph} interestType={selectedGraph} />
              )}
            </div>
            <div className="table-container">
              {dataToGraph && renderTables()}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <React.Fragment>
      <WebLoader isDataReady={isDataReady} />
      <div className="calculator-page page">
        {isDataReady && (
          <React.Fragment>
            <Banner
              mediaUrl={calculator.banners[0].path}
              title={calculator.banners[0]["title_" + lang]}
            />
            <div className="page-container" id="page-container">
              <Fade triggerOnce={true} duration={1000} fraction={0.3}>
              <div className="calculator-details">
                <div className="calculator-title-wrapper">
                  <h1
                    className="title"
                    dangerouslySetInnerHTML={{
                      __html:
                        calculator.edelmetalle_calculator["title_" + lang],
                    }}
                  />
                  {/* <Select value={selectedValue} onChange={handleSelectChange}>
                    {calculator.calculator_details.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select> */}
                </div>
                <p
                  className="desc"
                  dangerouslySetInnerHTML={{
                    __html:
                      calculator.edelmetalle_calculator["description_" + lang],
                  }}
                />
              </div>
              <div className="calculator-wrapper">
                <h2 className="gold-text bold-text">
                  {translate[lang].calculator.title}
                </h2>
                {renderCalculatorComponent()}
              </div>
              </Fade>
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export default Calculator;
